import {AggregatedLabReading, LabReading} from '../models'
import {
  assertArray,
  assertNumber,
  assertObjectOrUndefined,
  assertString,
} from '../utils'
import {AssertTypeFn, dateNormaliser} from './general'
import {facilityNormaliser} from './facilities'

export const labReadingNormaliser: AssertTypeFn<LabReading> = (obj) => ({
  id: assertString(obj.id),
  value: assertNumber(obj.value),
  date: assertObjectOrUndefined(obj.date, dateNormaliser),
  facility: assertObjectOrUndefined(obj.facility, facilityNormaliser),
})

export const labReadingsNormaliser: AssertTypeFn<LabReading[]> = (obj) =>
  assertArray(obj, labReadingNormaliser)

export const aggregatedLabReadingNormaliser: AssertTypeFn<
  AggregatedLabReading
> = (obj) => ({
  period: assertString(obj.period),
  value: assertNumber(obj.value),
})

export const aggregatedLabReadingsNormaliser: AssertTypeFn<
  AggregatedLabReading[]
> = (obj) => assertArray(obj, aggregatedLabReadingNormaliser)
